app.service('saveDeliveryData', function (modal, loading, broker, pageConfig, console, holidayPromotion) {
	let isSaved = false;

	function send(data, callback) {
		if(data.pickupPointCode && data.pickupPointCode == pageConfig.getData('order').pickupPointCode){
			console.log('NIE MA POTRZEBY ZAPISU PUNKTU');
			return;
		} else if(data.pickupPointCode && data.pickupPointCode == pageConfig.getData('order').parcelCode){
			console.log('NIE MA POTRZEBY ZAPISU PACZKOMATU');
			return;
		} else if(data.pickupPointCode && data.pickupPointCode == pageConfig.getData('order').shopCode){
			console.log('NIE MA POTRZEBY ZAPISU SKLEPU');
			return;
		}
		if (!isSaved) {
			isSaved = true;
			loading.start();
			$.ajax({
				url: '/order-path-pickup-point-delivery-edit.ltr',
				dataType: 'json',
				contentType: 'application/json',
				type: 'POST',
				data: JSON.stringify(data),
				success: function (json) {
					isSaved = false;
					if (json.status == 'SUCCESS') {
						holidayPromotion.refresh();
						broker.trigger('K3_REFRESH', function () {
							callback()
						});
					} else {
						modal.alert(json.messages);
					}
				},
				error: function () {
					isSaved = false;
					modal.alert('Błąd zapisania wybranego punktu odbioru. Spróbuj ponownie.')
				}
			});
		}
	}

	return {
		send
	};
});
